export function AtlasPage() {
  // This is a temporary solution to show the Atlas page in the backoffice required by partner team.
  // We will replace this with the actual Atlas page in the future.
  return (
    <iframe
      src={import.meta.env.VITE_ATLAS_URL}
      className="w-full h-full border-0"
      title="Atlas"
    />
  );
}

export default AtlasPage;
